
<!-- <div *ngIf="!isLoginPage()" class="layout-container">
  <app-header></app-header>
  <div class="main-container">
    <app-menu></app-menu>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</div>
<div *ngIf="isLoginPage()" class="layout-container">
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div> -->


<div *ngIf="!isLoginPage()" class="layout-container">
  <!-- Fixed Header -->
  <app-header></app-header>

  <!-- Main Content + Side Menu -->
  <div class="main-container">
    
    <!-- Side Menu -->
    <app-menu></app-menu>

    <!-- Scrollable Content -->
    <div class="content">
      <router-outlet></router-outlet>
     
    </div>

  </div>
   <app-footer></app-footer>
</div>
<div *ngIf="isLoginPage()" class="layout-container">
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div> 
